import React, { useState } from "react";
import PropTypes from "prop-types";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import { CardContent } from "@material-ui/core";
import axios from "axios";
import { baseUrl } from "helpers/Constants";
import PasswordResetter from "./PasswordResetter";

export default function AdminPasswordChanger({ userId, actorId, classes }) {
  const [changingPassword, setChangingPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(undefined);
  const [passwordStatus, setPasswordStatus] = useState("");

  function handlePasswordReset(newPassword) {
    setChangingPassword(true);
    setPasswordError(undefined);
    setPasswordStatus("");
    axios
      .post(`${baseUrl}auth/reset-password`, {
        userId,
        actorId,
        newPassword,
      })
      .then(() => {
        setChangingPassword(false);
        setPasswordStatus("SUCCESS");
      })
      .catch((error) => {
        setChangingPassword(false);
        setPasswordStatus("FAILED");
        //set errors
        console.log("xxx error", JSON.stringify(error.response));
        if (error.response.status === 400) {
          setPasswordError(error.response.data.message);
        }
      });
  }

  return (
    <Card>
      <CardHeader color="warning">
        <h3 className={classes.cardTitle}>Reset password for user</h3>
      </CardHeader>
      <CardContent>
        <PasswordResetter
          loading={changingPassword}
          onPasswordReset={handlePasswordReset}
          status={passwordStatus}
          userError={passwordError}
        />
      </CardContent>
    </Card>
  );
}
AdminPasswordChanger.propTypes = {
  userId: PropTypes.number.isRequired,
  actorId: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
};
